<div class="icon-container" [class]="getClassByType()">
    <mat-icon>{{ toast.icon }}</mat-icon>
</div>

<div class="text-container">
	<span>{{ toast.text }}</span>
</div>